module.exports = __webpack_public_path__ + "static/media/linkedinLight.6207b5f0.svg";